module.exports = __webpack_public_path__ + "static/media/fdc_logo.42dece3a.png";